/* Koemi Studio · product page behaviour (sections/km-product.liquid) */
(function () {
  function init(root) {
    if (!root || root.kmxReady) return;
    root.kmxReady = true;
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-kmx-data]').textContent); } catch (e) { return; }
    var variants = data.variants || [], L = data.labels || {};
    var form = root.querySelector('[data-kmx-form]');
    var idInput = root.querySelector('[data-kmx-id]');
    var atc = root.querySelector('[data-kmx-atc]');
    var atcLabel = root.querySelector('[data-kmx-atc-label]');
    var atcPrice = root.querySelector('[data-kmx-atc-price]');
    var now = root.querySelector('[data-kmx-price-now]');
    var was = root.querySelector('[data-kmx-price-was]');
    var save = root.querySelector('[data-kmx-price-save]');
    var err = root.querySelector('[data-kmx-err]');
    var pay = root.querySelector('[data-kmx-pay]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-kmx-opt]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- Gallery ---------- */
    var track = root.querySelector('[data-kmx-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-kmx-thumb]'));
    var count = root.querySelector('[data-kmx-count]');
    var prev = root.querySelector('[data-kmx-prev]'), next = root.querySelector('[data-kmx-next]');
    var index = 0;
    function go(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: instant || reduce ? 'auto' : 'smooth' });
    }
    function mark() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === index && thumbs.length && thumbs[i] && thumbs[i].classList.contains('is-on')) return;
      index = i;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
      if (count) count.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      slides.forEach(function (s, j) { if (j !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); } });
    }
    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; mark(); }); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-kmx-thumb'), 10)); }); });
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
      mark();
    }
    function showMedia(id) {
      if (!id) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(id)) { go(i); return; }
      }
    }

    /* ---------- Options ---------- */
    function chosen() {
      return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.o[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function current() {
      if (!groups.length) return variants[0] || null;
      return find(chosen());
    }
    function update(fromUser) {
      var opts = chosen();
      var v = current();
      groups.forEach(function (g, i) {
        var val = g.querySelector('[data-kmx-opt-val]');
        if (val && opts[i] != null) val.textContent = opts[i];
        g.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var m = find(test);
          inp.parentNode.classList.toggle('is-out', !m || !m.a);
        });
      });
      /* the paperclip chain is always gold vermeil, in the colour of the chosen charm */
      var chain = root.querySelector('[data-kmx-chain]');
      if (chain) {
        var withChain = opts.some(function (o) { return o && /paperclip chain/i.test(o); });
        var white = opts.some(function (o) { return o && /white gold/i.test(o); });
        chain.hidden = !withChain;
        chain.querySelector('[data-kmx-chain-metal]').textContent = '18K ' + (white ? 'White' : 'Yellow') + ' Gold Vermeil';
      }
      if (err) err.hidden = true;
      if (!v) {
        atc.disabled = true; atcLabel.textContent = L.unavailable; if (atcPrice) atcPrice.hidden = true;
        if (pay) pay.classList.add('is-out');
        return;
      }
      idInput.value = v.id;
      now.innerHTML = v.p;
      now.classList.toggle('is-sale', !!v.c);
      if (was) { was.hidden = !v.c; if (v.c) was.innerHTML = v.c; }
      if (save) { save.hidden = !v.s; if (v.s) save.textContent = 'Save ' + v.s + '%'; }
      atc.disabled = !v.a;
      /* a variant with a future "ships by" date (variant metafield custom.ships_by) is a preorder */
      var pre = false;
      if (v.sb) { try { pre = new Date(v.sb + 'T23:59:59') > new Date(); } catch (e) {} }
      atcLabel.textContent = v.a ? (pre ? (L.preorder || L.add) : L.add) : L.soldOut;
      if (atcPrice) { atcPrice.hidden = !v.a; atcPrice.innerHTML = v.p; }
      /* keep the container: the back-in-stock app puts its "Notify me" button in it */
      if (pay) pay.classList.toggle('is-out', !v.a);
      /* a variant can be made of a different material than the rest (variant metafield custom.metal) */
      var metal = root.querySelector('[data-kmx-metal]');
      if (metal) metal.textContent = v.mt || metal.getAttribute('data-default');
      if (fromUser) {
        showMedia(v.m);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      root.dispatchEvent(new CustomEvent('kmx:variant', { bubbles: true, detail: { id: v.id, title: v.t, price: v.p, available: v.a, shipsBy: pre ? v.sb : '' } }));
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
    update(false);

    /* ---------- Add to cart ---------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter !== atc) return; /* express checkout and app buttons submit normally */
        if (!window.kmCart || !window.FormData) return; /* no drawer: let the form post to the cart page */
        e.preventDefault();
        if (atc.disabled || atc.classList.contains('is-adding')) return;
        var label = atcLabel.textContent;
        atc.classList.add('is-adding');
        atcLabel.textContent = L.adding;
        if (err) err.hidden = true;
        window.kmCart.add(new FormData(form)).catch(function (ex) {
          if (err) { err.textContent = ex && ex.message ? ex.message : 'Something went wrong. Please try again.'; err.hidden = false; }
        }).then(function () {
          atc.classList.remove('is-adding');
          atcLabel.textContent = label;
        });
      });
    }
  }
  function all(scope) { (scope || document).querySelectorAll('[data-kmx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
